import {QueryKeys} from '../../../queryDefaults/QueryKeys';
import {useMutation, useQueryClient} from '@tanstack/react-query';
import {AppMedError} from '../../../error/AppMedError.ts';
import {ISimulationPayload, SimulationCurveGraph} from '../Simulation.ts';
import {SimulationApi} from '../../../apis/SimulationApi/SimulationApi.ts';

export function usePostSimulationRunMutation() {
    const queryClient = useQueryClient();

    return useMutation<SimulationCurveGraph | null, AppMedError, ISimulationPayload>({
        mutationKey: [QueryKeys.simulationCurveGraph],
        mutationFn: async (variables: ISimulationPayload) => {
            if (!variables.weight)
                return null
            return await SimulationApi.postSimulationRun(variables);
        },
        onSuccess: async (sim: SimulationCurveGraph | null) => {
            queryClient.setQueryData<SimulationCurveGraph>([QueryKeys.simulationCurveGraph], (prev) => {
                return sim ? sim : prev
            });
        },
    });
}